import React, { Component } from 'react';
import Mention from './Mention';

class BasicView extends Component{
	constructor(props){
		super(props);

		this.toggle = this.toggle.bind(this);

		this.state = { expanded: false };
	}

	toggle() {
		this.setState({ expanded: !this.state.expanded });
	}

    sentiment () {
        let sentimentClassName;
        if (this.props.overallSentiment) {
            if (this.props.overallSentiment.class === 'positive') {
                sentimentClassName = 'mention-sentiment-positive';
            } else if (this.props.overallSentiment.class === 'neutral') {
                sentimentClassName = 'mention-sentiment-neutral';
            } else if (this.props.overallSentiment.class === 'negative') {
                sentimentClassName = 'mention-sentiment-negative';
            }
        }
        return (
            <div className={ 'basic-sentiment-wrapper ' + sentimentClassName }>
                {(this.props.overallSentiment.score !== undefined) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Score : {this.props.overallSentiment.score}
                    </div>
                }
                <div>
                    <span className="fa fa-angle-double-right"/>Class : {this.props.overallSentiment.class}
                </div>
                <div>
                    <span className="fa fa-angle-double-right"/>Confidence : {this.props.overallSentiment.classConfidence}
                </div>
                {('topic' in this.props.overallSentiment) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Topic : {this.props.overallSentiment.topic}
                    </div>
                }
            </div>
        );
    }

    metadata () {
        return (
            <div className="basic-card-wrapper">
                {('salienceScore' in this.props && this.props.salienceScore != null) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Salience Score : {this.props.salienceScore.toFixed(4)}
                    </div>
                }
            </div>
        );
    }

	render() {
			return(

				<div className="mention">
                    {(this.props.overallSentiment || this.props.salienceScore) &&
                        <div>
                            {this.props.title &&
                                <h3 className="details-title">
                                    {this.props.title}
                                </h3>
                            }
                            {this.props.overallSentiment && this.sentiment()}
                            {this.metadata()}
                        </div>
                    }
					<h3 className="result-title" onClick={ this.toggle }>
						<span className={ this.state.expanded ?
							'result-toggle fa fa-chevron-down' :
							'result-toggle fa fa-chevron-right' } />
						{ this.props.label }
						
					</h3>
					<div className={ this.state.expanded ? 'results-body expanded' : 'results-body' }>
						{
							this.props.mentions.map((jsonResult, idx) =>
								<Mention key={ idx } jsonResult={ jsonResult }/>
							)
						}
					</div>
				</div>
				
			);	
		}
		
};

export default BasicView;
